import { parquePath, parques } from "@/content/parques";

/** "Otros parques." row on the home page: links into the /parques guides. */
const ParquesTeaser = () => (
  <section aria-labelledby="otros-parques-h" className="pq-section pq-mist">
    <div className="pq-wrap" style={{ display: "grid", gap: 40 }}>
      <div className="pq-split">
        <div style={{ display: "grid", gap: 16 }}>
          <h2 id="otros-parques-h" className="pq-headline">Otros parques.</h2>
          <p className="pq-lead">
            Si ya conoces el Tayrona: guías de otros parques nacionales de
            Colombia, con tarifas y datos del sitio oficial.
          </p>
        </div>
        <div className="pq-split-end">
          <a href="/parques" className="pq-btn pq-btn-primary">Ver todos los parques</a>
        </div>
      </div>
      <div className="pq-row pq-row-5">
        {parques.map((p) => (
          <a key={p.slug} href={parquePath(p)} className="pq-parkcard">
            <div className="pq-parkcard-img">
              <img
                src={p.fotos.portada.src}
                alt={p.fotos.portada.alt}
                width={p.fotos.portada.width}
                height={p.fotos.portada.height}
                loading="lazy"
                decoding="async"
              />
            </div>
            <span className="pq-title">{p.atractivoPrincipal}</span>
            <span className="pq-meta">{p.departamentos.join(", ")}</span>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default ParquesTeaser;
